import * as React from 'react'
import { useFormikContext } from 'formik'

import type {
  EditableCustomFieldProps,
  ICustomFieldValueFormModel,
} from './typings'
import { CustomFieldMultiSelect } from './atoms'
import { useHideOptional } from './useHideOptional'

export function EditableCustomMultiSelect(props: EditableCustomFieldProps) {
  const {
    field: { id: fieldId },
    avoidValidateOnBlur = false,
  } = props

  const {
    values: {
      customFields: { multi },
    },
  } = useFormikContext<ICustomFieldValueFormModel>()

  const selectedOptions = multi[fieldId]?.value ?? []

  const showField = useHideOptional(props)

  if (!showField) return null

  return (
    <CustomFieldMultiSelect
      type="multi"
      {...props}
      selectedOptions={selectedOptions}
      avoidValidateOnBlur={avoidValidateOnBlur}
    />
  )
}
